export const keywordFieldStyles = {
  wrapper: { alignItems: 'center !important' },
};
